import { createGlobalStyle } from 'styled-components';
import { normalize } from 'styled-normalize';

const GlobalStyle = createGlobalStyle`
  ${normalize};
  body {
    background-color: ${({ theme }) => theme.colors.SNOW_500};
    font-family: -apple-system, BlinkMacSystemFont, "Noto Sans", Roboto, Arial;
    position: relative;
  }

  * {
    box-sizing: border-box;
  };

  h1, h2, h3, h4, h5 {
    margin: 0;
  }

  /* Chrome, Safari, Edge, Opera */
  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  /* Firefox */
  input[type=number] {
    -moz-appearance: textfield;
  }
`;

export default GlobalStyle;
